var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessageBox } from '../../../common';
import { OrgConfigWizardContext } from '../../context';
import { StaffSettingsFormContent } from '../../staffSettings/StaffSettingsFormContent';
import { saveLocationStaffSettings, useStaffSettingsConfigAPI, } from '../../staffSettings/selectors';
import { getStaffSettingsFormError, mapLoadedWorkHoursToForm, staffSettingsFormToPayload, } from '../../staffSettings/validation';
var toBaseline = function (form) { return ({
    avgWeeklyAttrition: form.avgWeeklyAttrition,
    avgMonthlyAttrition: form.avgMonthlyAttrition,
    graduationRate: form.graduationRate,
    recruitingLeadTimeWeeks: form.recruitingLeadTimeWeeks,
    classSize: form.classSize,
    agent: form.agent,
    support: form.support,
}); };
var baselinesEqual = function (a, b) { return JSON.stringify(a) === JSON.stringify(b); };
var mapConfigToForm = function (cfg) {
    var _a, _b, _c, _d;
    return ({
        avgWeeklyAttrition: (_a = cfg.avgWeeklyAttrition) !== null && _a !== void 0 ? _a : '',
        avgMonthlyAttrition: (_b = cfg.avgMonthlyAttrition) !== null && _b !== void 0 ? _b : '',
        graduationRate: (_c = cfg.graduationRate) !== null && _c !== void 0 ? _c : '',
        recruitingLeadTimeWeeks: (_d = cfg.recruitingLeadTimeWeeks) !== null && _d !== void 0 ? _d : '',
        classSize: cfg.classSize == null ? '' : String(cfg.classSize),
        agent: mapLoadedWorkHoursToForm(cfg.agent),
        support: mapLoadedWorkHoursToForm(cfg.support),
        isDirty: false,
    });
};
export var ReviewStaffSettingsSection = function (_a) {
    var _b;
    var locationId = _a.locationId, registry = _a.registry, onFormChange = _a.onFormChange;
    var _c = useContext(OrgConfigWizardContext).isReadOnly, isReadOnly = _c === void 0 ? false : _c;
    var t = useTranslation('orgConfig', { keyPrefix: 'staffSettings' }).t;
    var _d = useStaffSettingsConfigAPI(locationId), configData = _d[0], fetchConfig = _d[1];
    var _e = useState({}), formMap = _e[0], setFormMap = _e[1];
    var _f = useState(undefined), validationError = _f[0], setValidationError = _f[1];
    var formMapRef = useRef(formMap);
    useEffect(function () {
        formMapRef.current = formMap;
    }, [formMap]);
    var baselineRef = useRef({});
    var form = (_b = formMap[locationId]) !== null && _b !== void 0 ? _b : null;
    useEffect(function () {
        if (form)
            onFormChange === null || onFormChange === void 0 ? void 0 : onFormChange(locationId, form);
    }, [form, locationId, onFormChange]);
    useEffect(function () {
        if (locationId)
            fetchConfig();
    }, [locationId, fetchConfig]);
    useEffect(function () {
        var data = configData.data;
        if (!data)
            return;
        setFormMap(function (prev) {
            var _a;
            var _b;
            if ((_b = prev[locationId]) === null || _b === void 0 ? void 0 : _b.isDirty)
                return prev;
            var mapped = mapConfigToForm(data);
            baselineRef.current[locationId] = toBaseline(mapped);
            return __assign(__assign({}, prev), (_a = {}, _a[locationId] = mapped, _a));
        });
    }, [configData.data, locationId]);
    var handleFormChange = useCallback(function (updater) {
        setValidationError(undefined);
        setFormMap(function (prev) {
            var _a;
            var current = prev[locationId];
            if (!current)
                return prev;
            return __assign(__assign({}, prev), (_a = {}, _a[locationId] = updater(current), _a));
        });
    }, [locationId]);
    var doSave = useCallback(function (locId, showValidationError) {
        if (showValidationError === void 0) { showValidationError = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var f, formError, baseline, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        f = formMapRef.current[locId];
                        if (!f)
                            return [2 /*return*/, true];
                        formError = getStaffSettingsFormError(f, t);
                        if (formError) {
                            if (showValidationError)
                                setValidationError({ message: formError });
                            return [2 /*return*/, false];
                        }
                        setValidationError(undefined);
                        if (!(f === null || f === void 0 ? void 0 : f.isDirty))
                            return [2 /*return*/, true];
                        baseline = baselineRef.current[locId];
                        if (baseline && baselinesEqual(toBaseline(f), baseline)) {
                            setFormMap(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), { isDirty: false }), _a)));
                            });
                            return [2 /*return*/, true];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, saveLocationStaffSettings(locId, staffSettingsFormToPayload(f))];
                    case 2:
                        _b.sent();
                        baselineRef.current[locId] = toBaseline(f);
                        setFormMap(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), { isDirty: false }), _a)));
                        });
                        return [2 /*return*/, true];
                    case 3:
                        _a = _b.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [t]);
    var scheduleDebouncedSave = useMemo(function () {
        return debounce(function (locId) {
            void doSave(locId, false);
        }, 500);
    }, [doSave]);
    useEffect(function () {
        if (!(form === null || form === void 0 ? void 0 : form.isDirty))
            return;
        scheduleDebouncedSave(locationId);
    }, [form, locationId, scheduleDebouncedSave]);
    useEffect(function () {
        registry.register('staffSettings', {
            flush: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    scheduleDebouncedSave.cancel();
                    return [2 /*return*/, doSave(locationId)];
                });
            }); },
            cancelPending: function () { return scheduleDebouncedSave.cancel(); },
            get isDirty() {
                var currentForm = formMapRef.current[locationId];
                return !!currentForm && (currentForm.isDirty || getStaffSettingsFormError(currentForm, t) !== null);
            },
        });
        return function () { return registry.unregister('staffSettings'); };
    }, [registry, locationId, scheduleDebouncedSave, doSave, t]);
    if (!form)
        return _jsx(Skeleton, { variant: "rectangular", height: 120, sx: { borderRadius: 1 } });
    return (_jsxs(_Fragment, { children: [_jsx(ErrorMessageBox, { errors: [validationError], onClose: function () { return setValidationError(undefined); } }), _jsx(StaffSettingsFormContent, { form: form, onChange: handleFormChange, disabled: isReadOnly })] }));
};
